"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerSourcesController = /** @class */ (function () {
    function CustomerSourcesController($stateParams) {
        this.$stateParams = $stateParams;
    }
    return CustomerSourcesController;
}());
CustomerSourcesController.$inject = ["$stateParams"];
exports.default = CustomerSourcesController;
